<div
  *ngIf="visible && message"
  class="form-error-container"
  role="alert"
  (click)="onClick()"
>
  <div class="alert alert-danger form-error-box">
    <div *ngIf="showStatus" class="form-error-title">
      Erreur{{ status ? " " + status : "" }}
    </div>

    <div class="form-error-message">
      {{ message }}
    </div>
  </div>
</div>
